import { z } from 'zod'

const brandIdSchema = z.enum(['proxyrequest'])

function optionalString(value: unknown): string | undefined {
  return typeof value === 'string' && value.trim() ? value.trim() : undefined
}

function readBrandId() {
  const raw = optionalString(import.meta.env.VITE_BRAND_ID)
  if (!raw && import.meta.env.DEV) return 'proxyrequest' as const
  return brandIdSchema.parse(raw)
}

function readApiBaseUrl() {
  const value = optionalString(import.meta.env.VITE_API_URL)
  if (value) return value.replace(/\/+$/, '')
  if (import.meta.env.DEV) return 'http://127.0.0.1:8000/api/v1'
  throw new Error('VITE_API_URL is required for production builds.')
}

export const env = Object.freeze({
  brandId: readBrandId(),
  apiBaseUrl: readApiBaseUrl(),
  siteName: optionalString(import.meta.env.VITE_SITE_NAME),
  siteNameUrl: optionalString(import.meta.env.VITE_SITE_NAME_URL),
  siteUrl: optionalString(import.meta.env.VITE_DOMAIN),
  uptimeUrl: optionalString(import.meta.env.VITE_UPTIME_URL),
  telegramUrl: optionalString(import.meta.env.VITE_TELEGRAM_URL),
  turnstileSiteKey: optionalString(import.meta.env.VITE_TURNSTILE_SITE_KEY),
  googleClientId: optionalString(import.meta.env.VITE_GOOGLE_CLIENT_ID),
  contactEmail: optionalString(import.meta.env.VITE_CONTACT_EMAIL),
  locale: optionalString(import.meta.env.VITE_LOCALE) ?? 'en',
  authStorageKey: `papaproxy.auth.${readBrandId()}`,
})

export type BrandId = z.infer<typeof brandIdSchema>
